module.exports = __webpack_public_path__ + "media/images/footer-logo@2x-985ebef88f8540bbb430e3182e7b8417.png";